/// <amd-module name="CodeCoverage/Clients/VC/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\testmanagement\vss-codecoverage-ci-web\clients\vc\vc.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "CodeCoverage/Clients/VC/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Get Item Metadata and/or Content for a single item. The download parameter is to indicate whether the content should be available as a download or just sent as a stream in the response. Doesn't apply to zipped content, which is always returned as a download.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param path - The item path.
     * @param project - Project ID or project name
     * @param scopePath - The path scope.  The default is null.
     * @param recursionLevel - The recursion level of this request. The default is 'none', no recursion.
     * @param includeContentMetadata - Set to true to include content metadata.  Default is false.
     * @param latestProcessedChange - Set to true to include the latest changes.  Default is false.
     * @param download - Set to true to download the response as a file.  Default is false.
     * @param versionDescriptor - Version descriptor.  Default is the default branch for the repository.
     * @param includeContent - Set to true to include item content when requesting json.  Default is false.
     * @param resolveLfs - Set to true to resolve Git LFS pointer files to return actual content from Git LFS.  Default is false.
     * @param sanitize - Set to true to sanitize an svg file and return it as image. Useful only if requested for svg file. Default is false.
     */
    getItem(repositoryId: string, path: string, project?: string, scopePath?: string, recursionLevel?: Git.VersionControlRecursionType, includeContentMetadata?: boolean, latestProcessedChange?: boolean, download?: boolean, versionDescriptor?: Git.GitVersionDescriptor, includeContent?: boolean, resolveLfs?: boolean, sanitize?: boolean): Promise<Git.GitItem>;
    /**
     * Get Item Metadata and/or Content for a single item. The download parameter is to indicate whether the content should be available as a download or just sent as a stream in the response. Doesn't apply to zipped content, which is always returned as a download.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param path - The item path.
     * @param project - Project ID or project name
     * @param scopePath - The path scope.  The default is null.
     * @param recursionLevel - The recursion level of this request. The default is 'none', no recursion.
     * @param includeContentMetadata - Set to true to include content metadata.  Default is false.
     * @param latestProcessedChange - Set to true to include the latest changes.  Default is false.
     * @param download - Set to true to download the response as a file.  Default is false.
     * @param versionDescriptor - Version descriptor.  Default is the default branch for the repository.
     * @param includeContent - Set to true to include item content when requesting json.  Default is false.
     * @param resolveLfs - Set to true to resolve Git LFS pointer files to return actual content from Git LFS.  Default is false.
     * @param sanitize - Set to true to sanitize an svg file and return it as image. Useful only if requested for svg file. Default is false.
     */
    getItemText(repositoryId: string, path: string, project?: string, scopePath?: string, recursionLevel?: Git.VersionControlRecursionType, includeContentMetadata?: boolean, latestProcessedChange?: boolean, download?: boolean, versionDescriptor?: Git.GitVersionDescriptor, includeContent?: boolean, resolveLfs?: boolean, sanitize?: boolean): Promise<string>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get Item Metadata and/or Content for a single item. The download parameter is to indicate whether the content should be available as a download or just sent as a stream in the response. Doesn't apply to zipped content, which is always returned as a download.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param path - The item path.
     * @param project - Project ID or project name
     * @param scopePath - The path scope.  The default is null.
     * @param recursionLevel - The recursion level of this request. The default is 'none', no recursion.
     * @param includeContentMetadata - Set to true to include content metadata.  Default is false.
     * @param latestProcessedChange - Set to true to include the latest changes.  Default is false.
     * @param download - Set to true to download the response as a file.  Default is false.
     * @param versionDescriptor - Version descriptor.  Default is the default branch for the repository.
     * @param includeContent - Set to true to include item content when requesting json.  Default is false.
     * @param resolveLfs - Set to true to resolve Git LFS pointer files to return actual content from Git LFS.  Default is false.
     * @param sanitize - Set to true to sanitize an svg file and return it as image. Useful only if requested for svg file. Default is false.
     */
    public async getItem(
        repositoryId: string,
        path: string,
        project?: string,
        scopePath?: string,
        recursionLevel?: Git.VersionControlRecursionType,
        includeContentMetadata?: boolean,
        latestProcessedChange?: boolean,
        download?: boolean,
        versionDescriptor?: Git.GitVersionDescriptor,
        includeContent?: boolean,
        resolveLfs?: boolean,
        sanitize?: boolean
        ): Promise<Git.GitItem> {

        const queryValues: any = {
            path: path,
            scopePath: scopePath,
            recursionLevel: recursionLevel,
            includeContentMetadata: includeContentMetadata,
            latestProcessedChange: latestProcessedChange,
            download: download,
            versionDescriptor: versionDescriptor,
            includeContent: includeContent,
            resolveLfs: resolveLfs,
            sanitize: sanitize
        };

        return this.beginRequest<Git.GitItem>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/Items/{*path}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

    /**
     * Get Item Metadata and/or Content for a single item. The download parameter is to indicate whether the content should be available as a download or just sent as a stream in the response. Doesn't apply to zipped content, which is always returned as a download.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param path - The item path.
     * @param project - Project ID or project name
     * @param scopePath - The path scope.  The default is null.
     * @param recursionLevel - The recursion level of this request. The default is 'none', no recursion.
     * @param includeContentMetadata - Set to true to include content metadata.  Default is false.
     * @param latestProcessedChange - Set to true to include the latest changes.  Default is false.
     * @param download - Set to true to download the response as a file.  Default is false.
     * @param versionDescriptor - Version descriptor.  Default is the default branch for the repository.
     * @param includeContent - Set to true to include item content when requesting json.  Default is false.
     * @param resolveLfs - Set to true to resolve Git LFS pointer files to return actual content from Git LFS.  Default is false.
     * @param sanitize - Set to true to sanitize an svg file and return it as image. Useful only if requested for svg file. Default is false.
     */
    public async getItemText(
        repositoryId: string,
        path: string,
        project?: string,
        scopePath?: string,
        recursionLevel?: Git.VersionControlRecursionType,
        includeContentMetadata?: boolean,
        latestProcessedChange?: boolean,
        download?: boolean,
        versionDescriptor?: Git.GitVersionDescriptor,
        includeContent?: boolean,
        resolveLfs?: boolean,
        sanitize?: boolean
        ): Promise<string> {

        const queryValues: any = {
            path: path,
            scopePath: scopePath,
            recursionLevel: recursionLevel,
            includeContentMetadata: includeContentMetadata,
            latestProcessedChange: latestProcessedChange,
            download: download,
            versionDescriptor: versionDescriptor,
            includeContent: includeContent,
            resolveLfs: resolveLfs,
            sanitize: sanitize
        };

        return this.beginRequest<string>({
            apiVersion: "5.0-preview.1",
            httpResponseType: "text/plain",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/Items/{*path}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

}

export const GitClientName = "Git_Coverage-Ci-WebPlatform.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
